module.exports = __webpack_public_path__ + "static/media/icon-userlogin.2be4c492.svg";